/* LIBRAIRIES */ 
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';

/* FIREBASE */
import { auth, firestore } from '../../firebase';
import { signInWithEmailAndPassword } from "firebase/auth";
import { collection, getDoc, doc } from 'firebase/firestore';

/* COMPONENTS */
import AuthDetails from '../../Components/Auth/AuthDetails';
import SignUp from '../../Components/Auth/SignUp';
import NewUser from '../../Components/NewUser/NewUser';
import CustomAlert from '../../Components/CustomAlert/CustomAlert';

/* MUI */
import { Button } from '@mui/material';
import TextField from '@mui/material/TextField';

/* CONTEXT */
import { UserContext } from '../../useContext';

/* ICONS */
import { AiOutlineMail } from 'react-icons/ai';
import { RiLockPasswordLine } from 'react-icons/ri';

/* LOADER */
import { Oval } from 'react-loader-spinner';

/* CSS */
import './Login.css';

const Login = () => {

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showLogin, setShowLogin] = useState(true); // état pour stocker quelle modale doit être affichée
    const [openAlert, setOpenAlert] = useState(false);
    const [alertSeverity, setAlertSeverity] = useState("success");
    const [alertMessage, setAlertMessage] = useState("");
    const navigate = useNavigate();
    const { setUserRole, setUserInfos } = useContext(UserContext); // récupération de la fonction setUserRole depuis le context

    const signIn = (e) => {
        setIsLoading(true);
        e.preventDefault();
        signInWithEmailAndPassword(auth, email, password)
        .then(async (userCredential) => {
            const userId = userCredential.user.uid;
            console.log(userId)
            const userDocRef = doc(firestore, "users", userId); // Référence du document de l'utilisateur
            try {
                const userDoc = await getDoc(userDocRef); // Récupération des données de l'utilisateur
                if (userDoc.exists()) {
                    const userData = userDoc.data();
                    console.log(userDoc, userData)
                    setUserInfos(userData); 
                    setUserRole(userData.role); // stockage du rôle dans le context
                } else {
                    setAlertSeverity("error");
                    setAlertMessage("Aucun document d'utilisateur trouvé");
                    setOpenAlert(true);
                    console.log("Aucun document d'utilisateur trouvé");
                }
                navigate('/Dashboard');
              } catch (error) {
                setAlertSeverity("error");
                setAlertMessage(error);
                setOpenAlert(true);
                console.log("Erreur lors de la récupération des données de l'utilisateur : ", error);
              }
            setTimeout(() => {
                navigate('/Dashboard');
                setIsLoading(false);
            }, 3000)
        }).catch((error) => {
            setAlertSeverity("error");
            setAlertMessage('Email / mot de passe invalide / inconnu');
            setOpenAlert(true);
            setIsLoading(false);
            console.log(error);
        })
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    }

    const toggleLogin = () => {
        setShowLogin(!showLogin);
    }
    
    const handleTransitionEnd = (e) => {
    // Supprimer les classes de transition après la fin de l'animation
    e.target.classList.remove('login-enter', 'login-exit', 'signup-enter', 'signup-exit');
    }

    return (
        <div className='containerLogin'>
            {
                <form className='modalConnexion' onSubmit={signIn}>
                    <p>Espace Client</p>
                    <div className='containerInput'>
                        <div className='containerInputLogin'>
                            <TextField id="filled-basic" type='email' label="Email" variant="filled" onChange={(e) => setEmail(e.target.value)}/>
                            <AiOutlineMail className='logoInputLogin'/>
                        </div>
                    </div>
                    <div className='containerInput'>
                        <div className='containerInputLogin'>
                            <TextField id="filled-basic" type='password' label="Password" variant="filled" onChange={(e) => setPassword(e.target.value)}/>
                            <RiLockPasswordLine className='logoInputLogin'/>
                        </div>
                    </div>
                    <Button variant="contained" onClick={signIn}>
                    {
                        isLoading ?
                        <Oval
                            height={25}
                            width={25}
                            color="white"
                            wrapperStyle={{}}
                            wrapperClass=""
                            visible={true}
                            ariaLabel='oval-loading'
                            secondaryColor="#4fa94d"
                            strokeWidth={2}
                            strokeWidthSecondary={2}
                            />
                        :
                        'Connexion'
                    }
                    </Button>
                </form> 
            }
                <CustomAlert 
                    open={openAlert}
                    onClose={handleCloseAlert}
                    message={alertMessage}
                    severity={alertSeverity}
                />
           
        </div>
    )
}

export default Login;